type OrdersFailureMap<R> = {
  serverFailure: () => R;
  networkFailure: () => R;
};

type OrdersFailureMaybeMap<R> = {
  serverFailure?: () => R;
  networkFailure?: () => R;
  orElse: () => R;
};

abstract class _OrdersFailure extends Error {
  public abstract map<R>(callbacks: OrdersFailureMap<R>): R;
  public abstract maybeMap<R>(callbacks: OrdersFailureMaybeMap<R>): R;
}

class ServerFailure extends _OrdersFailure {
  constructor() {
    super("ServerFailure");
  }

  public map<R>(callbacks: OrdersFailureMap<R>): R {
    return callbacks.serverFailure();
  }

  public maybeMap<R>(callbacks: OrdersFailureMaybeMap<R>): R {
    if (callbacks.serverFailure) return callbacks.serverFailure();
    return callbacks.orElse();
  }
}

class NetworkFailure extends _OrdersFailure {
  constructor() {
    super("NetworkFailure");
  }

  public map<R>(callbacks: OrdersFailureMap<R>): R {
    return callbacks.networkFailure();
  }

  public maybeMap<R>(callbacks: OrdersFailureMaybeMap<R>): R {
    if (callbacks.networkFailure) return callbacks.networkFailure();
    return callbacks.orElse();
  }
}

export type OrdersFailure = ServerFailure | NetworkFailure;

export const OrdersFailure = {
  serverFailure: () => new ServerFailure(),
  networkFailure: () => new NetworkFailure(),
};
